import React, {  } from 'react';
import { useTranslation } from 'react-i18next';

interface ChronogramLineHeaderProps {
  lineName: string;
  totalHour: string | undefined;
  offset: number
}

export const ChronogramLineHeader: React.FC<ChronogramLineHeaderProps> = ( {
  lineName,
  totalHour,
  offset,
} ) => {
  const { t } = useTranslation();

  return (
    <div className="h-full" style={{ gridColumn: `span ${offset}` }}>
      <div className="h-full pt-1 relative overflow-y-hidden">


        <div className="inline-flex place-content-between w-full pl-2">
          <h6
            className="text-xm font-medium text-gray-900 truncate"
            style={{ maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            title={lineName}
          >
            {lineName}
          </h6>

          { totalHour != undefined &&
            <div className="border text-sm px-1 font-medium text-center text-slate-600 border-slate-400 mt-1 w-fit mx-2 min-w-12 rounded" title={ t( 'translation:total_hours' )}>
              { totalHour }
            </div>
          }
        </div>

        {/* Remove hour/skills/abilities under user name for both tabs as per request */}

      </div>
    </div>
  );
};
